<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col">
        <div class="card card-default">
          <div class="card-header">
            <span class="ledger-title">{{ state.ledger.selectedLedger.name ? state.ledger.selectedLedger.name : 'loading...' }}</span>
            <ledger-settings
              v-if="state.ledger.selectedLedger.name && state.account.me"
              :key="'ledgerSettingsComponent' + ledgerId"
              :ledger-data="state.ledger.selectedLedger"
            />
          </div>

          <div class="card-body" style="padding-left: 0;padding-right: 0">
            <div v-if="error" class="alert alert-danger" style="margin-left: 5px;margin-right: 5px; margin-bottom: 15px;">{{ error }}</div>
            <ledger-content :expense-occurrences="state.ledger.selectedLedger.expenses" :key="state.ledger.selectedLedger.id"/>
          </div>
        </div>
      </div>
    </div>
    <create-expense :key="'createExpenseComponent' + ledgerId"/>
  </div>
</template>

<script>
import store from '../../store/index'
import { mapState, mapActions } from 'vuex'

import EditLedger from './EditLedger'
import LedgerContent from './LedgerContent'
import CreateExpense from './CreateExpense'

export default {
  name: 'Ledger',
  components: {
    'ledgerSettings': EditLedger,
    'ledgerContent': LedgerContent,
    'createExpense': CreateExpense
  },
  data () {
    return {
      error: '',
      _pusherChannelName: null,
      _pusherHandler: null
    }
  },
  computed: {
    ...mapState({
      state: state => state
    }),
    ledgerId () {
      return this.$route.params.id
    }
  },
  watch: {
    '$route' (to, from) {
      this.fetchData()
      this.pusherSetup()
    }
  },
  created () {
    /**
     * One thing to note when using routes with params is
     * that when the user navigates from /ledger/1 to /ledger/2, the same component instance will be reused.
     * Since both routes render the same component,
     * this is more efficient than destroying the old instance and then creating a new one.
     * However, this also means that the lifecycle hooks of the component will not be called.
     */
    let self = this
    this.fetchData()
    this.pusherSetup()
    if (!store.state.app.visibilityChangeObserver.ledger) {
      store.commit('SET_VISIBILITY_CHANGE_OBSERVER_LEDGER', true)
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          console.log('App in background!')
        } else {
          if (self.$router.currentRoute.name === 'Ledger') {
            self.pusherSetup()
            self.fetchData()
          }
        }
      })
    }
  },
  beforeDestroy () {
    if (this._pusherChannelName) {
      const ch = window.pusher.channel(this._pusherChannelName)
      if (ch && this._pusherHandler) {
        ch.unbind('ledger.updated', this._pusherHandler)
      }
      window.pusher.unsubscribe(this._pusherChannelName)
    }
  },
  methods: {
    ...mapActions([
      'getLedger'
    ]),
    fetchData () {
      this.$loading.startLoading('fetching-data-from-backend')
      this.getLedger(this.$route.params.id)
        .then((data) => {
          this.error = ''
          this.$loading.endLoading('fetching-data-from-backend')
        })
        .catch((data) => {
          this.error = data.message
          this.$loading.endLoading('fetching-data-from-backend')
        })
    },  
    pusherSetup () {
      const id = this.$route.params.id
      const channelName = 'private-ledger.' + id

      // Unbind + unsubscribe previous if different or exists
      if (this._pusherChannelName) {
        const prev = window.pusher.channel(this._pusherChannelName)
        if (prev && this._pusherHandler) {
          prev.unbind('ledger.updated', this._pusherHandler)
        }
        if (this._pusherChannelName !== channelName && prev) {
          window.pusher.unsubscribe(this._pusherChannelName)
        }
      }

      // Ensure channel exists
      const channel = window.pusher.channel(channelName) || window.pusher.subscribe(channelName)

      // Define handler once and bind
      this._pusherHandler = () => {
        this.getLedger(id)
      }
      // Remove any residual binding before re-bind (idempotent)
      channel.unbind('ledger.updated', this._pusherHandler)
      channel.bind('ledger.updated', this._pusherHandler)

      this._pusherChannelName = channelName
    }
  }
}
</script>
